import type { FeedbackSeed } from 'shared-ui/aurora'
import { create } from 'zustand'

interface AuroraChatStore {
  isOpen: boolean
  hasLoaded: boolean
  chatKey: number
  pendingFeedback: FeedbackSeed | undefined
  toggle: () => void
  close: () => void
  openWithFeedback: (seed: FeedbackSeed) => void
}

export const useAuroraChatStore = create<AuroraChatStore>((set) => ({
  isOpen: false,
  hasLoaded: false,
  chatKey: 0,
  pendingFeedback: undefined,
  toggle: () => set((s) => ({ isOpen: !s.isOpen, hasLoaded: true })),
  close: () => set({ isOpen: false }),
  openWithFeedback: (seed) =>
    set((s) => ({
      isOpen: true,
      hasLoaded: true,
      chatKey: s.chatKey + 1,
      pendingFeedback: seed
    }))
}))
